'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactScroll = require('react-scroll');

var _HeaderPhones = require('../HeaderPhones/HeaderPhones');var _HeaderPhones2 = _interopRequireDefault(_HeaderPhones);
var _components = require('../../../components');

var _CompanyInfoBlock = require('./CompanyInfoBlock.scss');var styles = _interopRequireWildcard(_CompanyInfoBlock);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Modules

var CompanyInfoBlock = function CompanyInfoBlock(props) {
  var handleClick = function handleClick(evt) {return evt.stopPropagation();};

  return (
    // eslint-disable-next-line max-len
    _react2.default.createElement(_components.CustomScrollLink, { offset: props.offset || (props.isMobile ? -90 : -95), to: props.scrollToBlock, spy: true, activeClass: styles.activeBlock, className: styles.companyInfoBlock },
      _react2.default.createElement('div', { onClick: handleClick, className: styles.container },
        !props.isMobile && _react2.default.createElement('div', { className: styles.title }, props.title),
        _react2.default.createElement('div', { className: styles.infoWr },
          _react2.default.createElement(_HeaderPhones2.default, {
            translate: props.translate,
            phoneNumber: props.phoneNumber,
            locale: props.locale,
            className: 'topBlock',
            isMobile: props.isMobile,
            isIconFill: true }),

          !props.isMobile && !props.isShowMoreInfo && _react2.default.createElement('span', { className: styles.or }, props.translate('or')),
          !props.isMobile && !props.isShowMoreInfo && _react2.default.createElement(_reactScroll.Link, { offset: -145, to: 'contacts-form-block', className: styles.anchor, smooth: true }, props.translate('forMoreInfo'))))));




}; // Styles
// Component
CompanyInfoBlock.propTypes = {
  title: _propTypes2.default.string,
  isShowPhone: _propTypes2.default.bool,
  onShowPhones: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  offset: _propTypes2.default.number,
  isShowMoreInfo: _propTypes2.default.bool,
  scrollToBlock: _propTypes2.default.string,
  phoneNumber: _propTypes2.default.string };exports.default =


CompanyInfoBlock;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/CompanyInfoBlock/CompanyInfoBlock.js
// module id = 2591
// module chunks = 0